module.exports = __webpack_public_path__ + "img/soleil@2x.15df26f.webp";